// src/components/UI/components/DropdownMenu/DropdownMenuGroup.tsx

import { Group } from '@radix-ui/react-dropdown-menu';

export const DropdownMenuGroup = Group;
DropdownMenuGroup.displayName = 'DropdownMenuGroup';
